<template>
  <div class="content package-student-page package-student-page--packages">
    <section ref="pageHero" class="ps-hero" :class="{ 'is-hidden': isHeroHidden }">
        <div class="ps-hero__main">
          <div class="ps-hero__icon"><i class="el-icon-collection-tag" /></div>
          <div>
            <h1>Quản lý gói giới hạn học sinh</h1>
            <p>Tạo và quản lý các gói giới hạn số lượng học sinh áp dụng cho từng trường trong hệ thống.</p>
          </div>
        </div>
        <div class="ps-hero__actions">
          <el-button plain icon="el-icon-school" @click="$router.push('/package-student/school-packages')">
            Áp dụng gói cho trường
          </el-button>
        </div>
    </section>

    <div class="ps-overview-sticky">
      <div ref="statsGrid" class="ps-stat-grid-package" :style="statsStyle">
        <div class="ps-stat-card">
          <div class="ps-stat-card__icon"><i class="el-icon-collection-tag" /></div>
          <div>
            <span class="ps-stat-card__value">{{ packageTotal }}</span>
            <span class="ps-stat-card__label">Tổng số gói</span>
          </div>
        </div>
        <div class="ps-stat-card ps-stat-card--green">
          <div class="ps-stat-card__icon"><i class="el-icon-circle-check" /></div>
          <div>
            <span class="ps-stat-card__value">{{ activeCount }}</span>
            <span class="ps-stat-card__label">Đang sử dụng</span>
          </div>
        </div>
        <div class="ps-stat-card ps-stat-card--orange">
          <div class="ps-stat-card__icon"><i class="el-icon-warning-outline" /></div>
          <div>
            <span class="ps-stat-card__value">{{ inactiveCount }}</span>
            <span class="ps-stat-card__label">Ngưng sử dụng</span>
          </div>
        </div>
<!--        <div class="ps-stat-card ps-stat-card&#45;&#45;red">-->
<!--          <div class="ps-stat-card__icon"><i class="el-icon-info" /></div>-->
<!--          <div>-->
<!--            <span class="ps-stat-card__value">{{ latestPackageLimit | formatNumber }}</span>-->
<!--            <span class="ps-stat-card__label">Giới hạn gói mới nhất</span>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>

    <section class="ps-card ps-card--list" :style="cardLayoutStyle">
      <div ref="cardTop" class="ps-card__top">
        <div class="ps-card__heading">
        <div class="ps-card__heading-left">
          <div class="ps-card__heading-icon"><i class="el-icon-box" /></div>
          <div>
            <h2>Danh sách gói giới hạn</h2>
            <p>Mã gói không thể chỉnh sửa sau khi tạo để đảm bảo tính duy nhất.</p>
          </div>
        </div>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreateDialog">
          Thêm gói
        </el-button>
        </div>

        <div class="ps-toolbar">
        <div class="ps-toolbar__left">
          <el-form class="ps-toolbar__filters" inline label-position="top" @submit.native.prevent>
            <el-form-item label="Tìm theo mã / tên gói">
              <el-input
                v-model="search"
                size="small"
                clearable
                prefix-icon="el-icon-search"
                placeholder="Nhập mã hoặc tên gói"
                style="width: 220px"
              />
            </el-form-item>
            <el-form-item label="Trạng thái gói">
              <el-select v-model="activeFilter" size="small" style="width: 145px">
                <el-option label="Tất cả" value="all" />
                <el-option label="Đang sử dụng" value="active" />
                <el-option label="Ngưng sử dụng" value="inactive" />
              </el-select>
            </el-form-item>
            <el-button
              v-if="hasActiveFilters"
              class="ps-filter-reset"
              type="text"
              icon="el-icon-refresh-left"
              @click="resetFilters"
            >
              Đặt lại
            </el-button>
          </el-form>
        </div>
        <div class="ps-toolbar__actions">
          <span v-if="selectedPackages.length" class="ps-selected-count">
            Đã chọn {{ selectedPackages.length }} gói
          </span>
          <el-dropdown
            trigger="click"
            :disabled="!selectedPackages.length || batchSaving"
            @command="handleBulkAction"
          >
            <el-button
              size="small"
              type="primary"
              plain
              :loading="batchSaving"
              :disabled="!selectedPackages.length"
            >
              Tác vụ <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="activate" icon="el-icon-video-play">
                  Kích hoạt gói đã chọn
                </el-dropdown-item>
                <el-dropdown-item command="deactivate" icon="el-icon-video-pause">
                  Ngưng sử dụng gói đã chọn
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
        </div>
      </div>

      <div class="ps-card__table">
        <el-table
          v-loading="loading"
          :data="paginatedPackages"
          border
          stripe
          class="sk-table ps-table"
          ref="packageTable"
          :max-height="760"
          empty-text="Chưa có gói giới hạn nào"
          @selection-change="handleSelectionChange"
        >
        <el-table-column type="selection" width="52" align="center" fixed="left" />
        <el-table-column
          label="STT"
          type="index"
          width="58"
          align="center"
        />
        <el-table-column label="Mã gói" prop="code" min-width="150">
          <template slot-scope="{ row }">
            <span class="ps-package-code">{{ row.code }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Tên gói" prop="name" min-width="220">
          <template slot-scope="{ row }">
            <span class="ps-package-name">{{ row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Số giới hạn" prop="limit" width="150" align="right">
          <template slot-scope="{ row }">
            <span class="ps-limit-value">{{ row.limit | formatNumber }} HS</span>
          </template>
        </el-table-column>
        <el-table-column label="Ngày tạo" prop="createdAt" width="145" align="center">
          <template slot-scope="{ row }">{{ row.createdAt | formatDate }}</template>
        </el-table-column>
        <el-table-column label="Trạng thái" width="145" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.active ? 'success' : 'info'" size="small" effect="light">
              <i :class="row.active ? 'el-icon-circle-check' : 'el-icon-remove-outline'" />
              {{ row.active ? 'Đang sử dụng' : 'Ngưng sử dụng' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Thao tác" width="160" align="center" fixed="right">
          <template slot-scope="{ row }">
            <div class="ps-action-row">
              <el-tooltip content="Chỉnh sửa gói" placement="top">
                <el-button type="primary" plain circle size="mini" icon="el-icon-edit" @click="openEditDialog(row)" />
              </el-tooltip>
              <el-tooltip :content="row.active ? 'Ngưng sử dụng' : 'Kích hoạt lại'" placement="top">
                <el-button
                  :type="row.active ? 'warning' : 'success'"
                  plain
                  circle
                  size="mini"
                  :icon="row.active ? 'el-icon-video-pause' : 'el-icon-video-play'"
                  @click="toggleActive(row)"
                />
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        </el-table>
      </div>

      <div class="ps-pagination">
        <el-pagination
          small
          background
          layout="total, sizes, prev, pager, next"
          :current-page="currentPage"
          :page-size="pageSize"
          :page-sizes="[5, 10, 20]"
          :total="packageTotal"
          @current-change="handlePageChange"
          @size-change="handlePageSizeChange"
        />
      </div>
    </section>

    <PackageFormDialog
      :visible.sync="dialogVisible"
      :editing-package="editingPackage"
      :saving="saving"
      @submit="handleSavePackage"
    />
  </div>
</template>

<script>
import PackageFormDialog from "./components/dialog/PackageFormDialog.vue";
import PackageService from "./services/PackageService";

export default {
  name: "PackageManagementPage",
  components: { PackageFormDialog },
  data() {
    return {
      packages: [],
      allPackages: [],
      packageTotal: 0,
      loading: false,
      saving: false,
      search: "",
      activeFilter: "all",
      currentPage: 1,
      pageSize: 10,
      pageScrollEl: null,
      pageScrollTop: 0,
      heroHeight: 0,
      heroHidden: false,
      cardTopHeight: 0,
      statsGridHeight: 0,
      dialogVisible: false,
      editingPackage: null,
      selectedPackages: [],
      batchSaving: false,
      searchTimer: null,
    };
  },
  computed: {
    filteredPackages() {
      return this.packages;
    },
    paginatedPackages() {
      return this.packages;
    },
    statsStyle() {
      const collapseProgress = Math.min(this.pageScrollTop / 160, 1);
      return {
        opacity: 1 - collapseProgress,
        maxHeight: this.statsGridHeight
          ? `${this.statsGridHeight * (1 - collapseProgress)}px`
          : undefined,
        marginBottom: `${14 * (1 - collapseProgress)}px`,
        transform: `translateY(-${Math.min(this.pageScrollTop / 5, 10)}px)`,
      };
    },
    isHeroHidden() {
      return this.heroHidden;
    },
    cardLayoutStyle() {
      return {
        "--ps-card-top-height": `${this.cardTopHeight}px`,
      };
    },
    hasActiveFilters() {
      return Boolean(
        this.search
        || this.activeFilter !== "all"
      );
    },
    selectedPackageCodes() {
      return this.selectedPackages.map((item) => item.code).join(", ");
    },
    batchActionLabel() {
      return this.selectedPackages.length === 1
        ? "gói đã chọn"
        : `${this.selectedPackages.length} gói đã chọn`;
    },
    selectedPackageIds() {
      return this.selectedPackages.map((item) => item.id);
    },
    hasSelection() {
      return this.selectedPackages.length > 0;
    },
    activeCount() {
      return this.allPackages.filter((item) => item.active).length;
    },
    inactiveCount() {
      return this.allPackages.filter((item) => !item.active).length;
    },
    latestPackageLimit() {
      if (!this.allPackages.length) return 0;
      return this.allPackages.reduce((latest, item) => (
        new Date(item.createdAt) > new Date(latest.createdAt) ? item : latest
      )).limit;
    },
  },
  created() {
    this.fetchPackages();
  },
  mounted() {
    this.bindPageScroll();
    this.$nextTick(() => {
      this.measureStatsGrid();
      this.measureStickyHeights();
      this.handlePageScroll({ target: this.pageScrollEl });
    });
  },
  updated() {
    this.$nextTick(this.measureStickyHeights);
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
    if (this.pageScrollEl) {
      this.pageScrollEl.removeEventListener("scroll", this.handlePageScroll);
    }
  },
  watch: {
    search() {
      this.scheduleFetch();
    },
    activeFilter() {
      this.scheduleFetch();
    },
  },
  methods: {
    measureStatsGrid() {
      if (this.$refs.statsGrid) {
        this.statsGridHeight = this.$refs.statsGrid.scrollHeight;
      }
    },
    measureStickyHeights() {
      const heroHeight = this.$refs.pageHero ? this.$refs.pageHero.offsetHeight : 0;
      const cardTopHeight = this.$refs.cardTop ? this.$refs.cardTop.offsetHeight : 0;
      if (heroHeight && heroHeight !== this.heroHeight) this.heroHeight = heroHeight;
      if (cardTopHeight && cardTopHeight !== this.cardTopHeight) this.cardTopHeight = cardTopHeight;
    },
    bindPageScroll() {
      this.pageScrollEl = this.$el;
      if (this.pageScrollEl) {
        this.pageScrollEl.addEventListener("scroll", this.handlePageScroll, { passive: true });
      }
    },
    handlePageScroll(event) {
      if (event && event.target) {
        const nextScrollTop = Math.max(event.target.scrollTop, 0);
        this.pageScrollTop = nextScrollTop;
        if (nextScrollTop === 0) {
          this.heroHidden = false;
        } else if (this.heroHeight && nextScrollTop >= this.heroHeight) {
          this.heroHidden = true;
        }
      }
    },
    fetchPackages() {
      this.loading = true;
      const active = this.activeFilter === "all"
        ? undefined
        : this.activeFilter === "active";
      Promise.all([
        PackageService.search({
          keyword: this.search,
          active,
          page: this.currentPage - 1,
          size: this.pageSize,
        }),
        PackageService.getAll(false),
      ])
        .then(([result, allPackages]) => {
          this.packages = result.items;
          this.packageTotal = result.total;
          this.allPackages = allPackages;
        })
        .catch((error) => this.showError(error))
        .finally(() => { this.loading = false; });
    },
    scheduleFetch() {
      this.currentPage = 1;
      this.clearSelection();
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.fetchPackages(), 300);
    },
    openCreateDialog() {
      this.editingPackage = null;
      this.dialogVisible = true;
    },
    resetFilters() {
      this.search = "";
      this.activeFilter = "all";
      this.currentPage = 1;
      this.clearSelection();
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.clearSelection();
      this.fetchPackages();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.clearSelection();
      this.fetchPackages();
    },
    handleSelectionChange(selection) {
      this.selectedPackages = selection;
    },
    clearSelection() {
      this.selectedPackages = [];
      if (this.$refs.packageTable) {
        this.$refs.packageTable.clearSelection();
      }
    },
    handleBulkAction(command) {
      if (!this.hasSelection) return;
      const active = command === "activate";
      const actionText = active ? "kích hoạt" : "ngưng sử dụng";
      const packageCodes = this.selectedPackageCodes;

      this.$confirm(
        `Bạn có chắc muốn ${actionText} ${this.batchActionLabel}? (${packageCodes})`,
        "Xác nhận tác vụ hàng loạt",
        { type: active ? "success" : "warning", confirmButtonText: "Xác nhận", cancelButtonText: "Hủy" },
      )
        .then(() => {
          this.batchSaving = true;
          return PackageService.setActiveMany(this.selectedPackageIds, active);
        })
        .then((result) => {
          this.showBatchResult(result, actionText);
          this.clearSelection();
          this.fetchPackages();
        })
        .catch((error) => {
          if (error !== "cancel" && error !== "close") this.showError(error);
        })
        .finally(() => { this.batchSaving = false; });
    },
    openEditDialog(item) {
      this.editingPackage = item;
      this.dialogVisible = true;
    },
    handleSavePackage(form) {
      this.saving = true;
      const request = this.editingPackage
        ? PackageService.update(this.editingPackage.id, form)
        : PackageService.create(form);

      request
        .then((result) => {
          if (result && result.failCount > 0) {
            const failureMessage = this.getBatchFailureMessage(result);
            this.$message.warning(failureMessage);
            if (!result.successCount) return;
          } else {
            this.$message.success(this.editingPackage ? "Đã cập nhật gói" : "Đã tạo gói mới");
          }
          this.dialogVisible = false;
          this.fetchPackages();
        })
        .catch((error) => this.showError(error))
        .finally(() => { this.saving = false; });
    },
    toggleActive(item) {
      const nextActive = !item.active;
      const actionText = nextActive ? "kích hoạt lại" : "ngưng sử dụng";
      this.$confirm(
        `Bạn có chắc muốn ${actionText} gói ${item.code}?`,
        "Xác nhận thao tác",
        { type: nextActive ? "success" : "warning", confirmButtonText: "Xác nhận", cancelButtonText: "Hủy" },
      )
        .then(() => PackageService.setActive(item.id, nextActive))
        .then((result) => {
          if (result && result.failCount > 0) {
            this.$message.error(this.getBatchFailureMessage(result));
            return;
          }
          this.$message.success(`Đã ${actionText} gói ${item.code}`);
          this.fetchPackages();
        })
        .catch((error) => {
          if (error !== "cancel" && error !== "close") this.showError(error);
        });
    },
    showError(error) {
      const responseMessage = error && error.response && error.response.data
        ? error.response.data.message
        : null;
      this.$message.error(responseMessage || (error && error.message)
        || "Có lỗi xảy ra, vui lòng thử lại");
    },
    getBatchFailureMessage(result) {
      const failed = (result.results || []).find((item) => !item.success);
      return failed && failed.message
        ? failed.message
        : `Có ${result.failCount} dòng không cập nhật được`;
    },
    showBatchResult(result, actionText) {
      if (result && result.failCount > 0) {
        this.$message.warning(
          `${actionText}: thành công ${result.successCount || 0}, thất bại ${result.failCount}`,
        );
        return;
      }
      this.$message.success(`Đã ${actionText} ${this.batchActionLabel}`);
    },
  },
};
</script>

<style lang="scss">
@import "./styles/package-student.scss";
</style>
